const $ = jQuery;

class HubspotForms {
	init() {
		// HUBSPOT FORMS
        $('[data-hubspot-form]').each(function(){
            
            if( $(this).attr('data-hubspot-form') ) {
                if( ! $(this).attr('id') ) $(this).attr('id', 'hubspot-form--' + $(this).attr('data-hubspot-form'));

                const jobTitle = $(this).attr('data-job-title');

                var hubspot_vars = {
                    portalId	: $(this).attr('data-hubspot-portal-id'),
                    formId		: $(this).attr('data-hubspot-form'),
                    target		: '#' + $(this).attr('id'),
                    cssRequired	: '',
                    css         : '',
                    locale		: $('html').attr('lang'),
                    onFormReady : function(form) {
                        if ( jobTitle ) {
                            $( form ).find('input[name="jobtitle"]').val( jobTitle );
                        }
                    },
                    onFormSubmit : function(form) {
                        
                        // EXAMPLE OF CUSTOM HANDLING BY FORM ID
                        // if( $(form).is('[data-form-id="bae9882a-6b1c-4e49-bf8b-96614cb3088a"]') ) {
                        // 	var summary = [];
                        // 	$('.summary_of_inputs .selection-content').each(function(){
                        // 		summary.push( $(this).text() );
                        // 	});
                        // 	var summary_text = summary.join('; ');
                        // 	$('[name="summary_of_your_inputs"]').val( summary_text );
                        // 	return false;
                        // }
                    },
                    onFormSubmitted : function(form) {

                    }

                };
            
                if( $(this).attr('data-css') !== undefined ) hubspot_vars.css = $(this).attr('data-css');
                hbspt.forms.create(hubspot_vars);
            }
        });
	}
}

export default new HubspotForms;